module.exports = __webpack_public_path__ + "static/img/p-14.f963e0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-14.png
// module id = KLZO
// module chunks = 0